import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

const Sidebar = () => {
    const location = useLocation();
    const { authUser } = useAuth();
    const currentRole = authUser?.user_type;

    const getNavItems = () => {
        if (currentRole === 'admin') {
            return [
                { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
                { path: '/admin/orders', label: 'Orders', icon: '📦' },
                { path: '/admin/users', label: 'Users', icon: '👥' },
                { path: '/admin/pumps', label: 'Petrol Pumps', icon: '⛽' },
                { path: '/admin/managers', label: 'Managers', icon: '👔' },
                { path: '/admin/agents', label: 'Agents', icon: '👤' },
                { path: '/admin/settlements', label: 'Settlements', icon: '💰' },
                { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
                { path: '/admin/cms', label: 'CMS', icon: '📰' },

            ];
        } else if (currentRole === 'manager') {
            return [
                { path: '/manager/dashboard', label: 'Dashboard', icon: '📊' },
                { path: '/manager/orders', label: 'Orders', icon: '📦' },
                { path: '/manager/earnings', label: 'Earnings', icon: '💰' },
                { path: '/manager/profile', label: 'Profile', icon: '👤' },
            ];
        } else if (currentRole === 'agent') {
            return [
                { path: '/agent/dashboard', label: 'Dashboard', icon: '📊' },
                { path: '/agent/referrals', label: 'Referrals', icon: '🔗' },
                { path: '/agent/points', label: 'Points & Redemption', icon: '⭐' },
                { path: '/agent/profile', label: 'Profile', icon: '👤' },
            ];
        }
        return [];
    };

    const navItems = getNavItems();

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <div className="sidebar-logo">
                    <img
                        src="/logo-2.png"
                        alt="Apna Pump Logo"
                        className="sidebar-logo-icon"
                    />
                </div>
            </div>
            <nav className="sidebar-nav">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
                        >
                            <span className="sidebar-nav-icon">{item.icon}</span>
                            <span className="sidebar-nav-label">{item.label}</span>
                        </Link>
                    );
                })}
            </nav>
        </aside>
    );
};

export default Sidebar;

